
import { VSheet } from "vuetify/lib";

export default VSheet.extend({});
